// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"style_loadingWrapper__6nl7q"};